import $ from "jquery";
import * as bootstrap from 'bootstrap'
import slick from 'slick-carousel'

window.$ = window.jQuery = $;
window.bootstrap = bootstrap
window.responsive = {
    breakpoints: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400
    },
    isMobile: window.innerWidth < 992,
}
window.onceLoaded = callback => {
    if (typeof callback === "function") {
        if (window.isLoaded && window.isReady) {
            callback()
        } else {
            $(window).one('load', callback)
        }
    }
}
window.readyResize = callback => {
    if (typeof callback === "function") {
        $(document).ready(() => {
            callback()
        })
        $(window).resize(() => {
            responsive.isMobile = window.innerWidth < responsive.breakpoints.md
            callback()
        })
    }
}
(function () {
    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
    var isWebkit = navigator.userAgent.toLowerCase().indexOf( 'webkit' ) > -1,
        isOpera  = navigator.userAgent.toLowerCase().indexOf( 'opera' )  > -1,
        isIe     = navigator.userAgent.toLowerCase().indexOf( 'msie' )   > -1;

    if ( ( isWebkit || isOpera || isIe ) && document.getElementById && window.addEventListener ) {
        window.addEventListener( 'hashchange', function() {
            var id = location.hash.substring( 1 ),
                element;

            if ( ! ( /^[A-z0-9_-]+$/.test( id ) ) ) {
                return;
            }

            element = document.getElementById( id );

            if ( element ) {
                if ( ! ( /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) ) {
                    element.tabIndex = -1;
                }

                element.focus();
            }
        }, false );
    }

})();

window.isLoaded = false;
window.isReady = false;

$(window).one('load', () => {
    window.isLoaded = true;
    // trigger resize to handle some component layout (eg: categoryProducts)
    $(window).trigger('resize');
})
$(() => {
    console.log('once loaded - base.js');
    const $html = $('html');
    const userAgent = navigator.userAgent.toLowerCase();
    if (/chrome/.test(userAgent) && /android/.test(userAgent)) {
        window.isChromeAndroid = true;
        $html.addClass('is-chrome-android');
    } else if (/crios/.test(userAgent)) {
        window.isChromeIos = true;
        $html.addClass('is-chrome-ios');
    } else if (/firefox/.test(userAgent)) {
        window.isFirefox = true;
        $html.addClass('is-firefox');
    } else if (
        !/crios/.test(userAgent) &&
        /webkit/.test(userAgent) &&
        (/iphone/.test(userAgent) || /ipad/.test(userAgent) || /ipod/.test(userAgent))
    ) {
        window.isSafariIos = true;
        $html.addClass('is-safari-ios');
    } else if (/msie|Trident/.test(navigator.userAgent)) {
        window.isInternetExplorer = true;
        $html.addClass('is-internet-explorer');
    } else if (/edge/.test(userAgent)) {
        window.isInternetExplorer = true;
        $html.addClass('is-microsoft-edge');
    }
    // detect ios or android
    if (/iPad|iPhone|iPod/i.test(userAgent)) {
        window.isIos = true;
        $html.addClass('is-ios');
    } else if (/android/.test(userAgent)) {
        window.isAndroid = true;
        $html.addClass('is-android');
    }

    window.isReady = true;

    onceLoaded(() => {

        window.body = $('body');
        window.html = $('html');

        const $goBackLinks = $('a[href*=".back()"]');
        if ($goBackLinks.length) {
            const previousPage = document.referrer;
            const previousDomain = previousPage.match(/https?\:\/\/.*?\//);
            $goBackLinks.each((index, el) => {
                const $currentLink = $(el);
                $currentLink.off('.go-back').on('click.go-back', (evt) => {
                    const homePageURL = window.location.origin + window.Utils.global.getBaseUrl() + '.html';
                    const homePageDomain = homePageURL.match(/https?\:\/\/.*?\//);
                    if (previousPage === "" || (previousDomain[0] !== homePageDomain[0])) {
                        evt.preventDefault();
                        window.location.href = homePageURL;
                    }
                });
            });
        }
    })

})
